import request from '@/utils/request'


// 查询订单项列表
export function listOrderItem(query) {
  return request({
    url: '/orderItem/orderItem/list',
    method: 'get',
    params: query
  })
}

// 查询订单项分页
export function pageOrderItem(query) {
  return request({
    url: '/orderItem/orderItem/page',
    method: 'get',
    params: query
  })
}

// 查询订单项详细
export function getOrderItem(data) {
  return request({
    url: '/orderItem/orderItem/detail',
    method: 'get',
    params: data
  })
}

// 新增订单项
export function addOrderItem(data) {
  return request({
    url: '/orderItem/orderItem/add',
    method: 'post',
    data: data
  })
}

// 修改订单项
export function updateOrderItem(data) {
  return request({
    url: '/orderItem/orderItem/edit',
    method: 'post',
    data: data
  })
}
export function editLogistics(data) {
  return request({
    url: '/orderItem/orderItem/editLogistics',
    method: 'post',
    data: data
  })
}

// 删除订单项
export function delOrderItem(data) {
  return request({
    url: '/orderItem/orderItem/delete',
    method: 'post',
    data: data
  })
}
export function bathDeliver(data) {
  return request({
    url: '/orderItem/orderItem/bathDeliver',
    method: 'post',
    data: data
  })
}

